import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Settings } from '../../lib/app.constant';
import { BehaviorSubject } from 'rxjs';
import { IS_SHOW_LOADER } from '../../lib/custom-context';

@Injectable({
  providedIn: 'root'
})
export class AdministrationService {

  selectedClientId$ = new BehaviorSubject<string | null>(localStorage.getItem('selectedClientId') || null);
  privilegeList$ = new BehaviorSubject<any[]>(
    this.getPrivilegesFromLocalStorage()
  ); 
  
  setSelectedClientId(clientId: string) {
    this.selectedClientId$.next(clientId);
  }

  setPrivilegeList(privileges: any) {
    const currentPrivileges = JSON.parse(localStorage.getItem('RolePrivilege')) || [];

    // Only write if changed:
    if (JSON.stringify(currentPrivileges) === JSON.stringify(privileges)) {
      return;
    }

    if (privileges.length > 0) {
      localStorage.setItem('RolePrivilege', JSON.stringify(privileges));
    }

    this.privilegeList$.next(privileges.length > 0 ? privileges : currentPrivileges);
  }

  clientId = localStorage.getItem('selectedClientId') || 1;

  constructor(private http: HttpClient) {
    window.addEventListener('storage', (event) => {
      if (event.key === 'RolePrivilege') {
        this.updatePrivilegeListFromStorage();
      }
    });
    setInterval(() => {
      const latestPrivileges = this.getPrivilegesFromLocalStorage();
      const currentPrivileges = this.privilegeList$.getValue();
      this.clientId = localStorage.getItem('selectedClientId') || 1;
      if (JSON.stringify(latestPrivileges) !== JSON.stringify(currentPrivileges)) {
        this.privilegeList$.next(latestPrivileges);
      }
    }, 3000);
  }

  private getPrivilegesFromLocalStorage(): any[] {
    try {
      const stored = localStorage.getItem('RolePrivilege');
      return stored ? JSON.parse(stored) : [];
    } catch (error) {
      console.error('Error parsing RolePrivilege from localStorage:', error);
      return [];
    }
  }
  updatePrivilegeListFromStorage() {
    const updatedPrivileges = JSON.parse(localStorage.getItem('RolePrivilege') || 'null');
    this.privilegeList$.next(updatedPrivileges);
  }

  getAllUser(body: {}, isExport: boolean = false) {
    if (!isExport) {
      return this.http.post(environment.baseApiUrl + 'user/v1/list', body);
    }
    else {
      return this.http.post(environment.baseApiUrl + 'user/v1/list', body, { observe: 'response', responseType: 'blob' });
    }
  }
  getUserById(id: string){
    return this.http.get(environment.baseApiUrl + 'user/v1/' + id+"?client_id="+ this.clientId);
  }
  addUser(body: {}) {
    return this.http.post(environment.baseApiUrl + 'user/v1/register', body);
  }

  updateUser(body: {}, id: string) {
    return this.http.put(environment.baseApiUrl + 'user/v1/' + id, body);
  }
  changeSuperUser(body: {}) {
    return this.http.post(environment.baseApiUrl + 'user/v1/toggle-superuser-status', body);
  }
  deleteUser(id: string) {
    return this.http.delete(environment.baseApiUrl + 'user/v1/' + id);
  }

  getApplicationRoleDataAccess(id) {
    return this.http.get(environment.baseApiUrl + 'user/v1/' + id)
  }
  getColumnSettingsList(body: {}, isExport: boolean = false) {
    const url = `${environment.baseApiUrl}config/v1/bulk-configurations/list`;

    if (!isExport) {
      return this.http.post(url, body);
    } else {
      return this.http.post(url, body, { observe: 'response', responseType: 'blob' });
    }
  }

  getUserColumnSettingsList(module_id, application_id) {
    return this.http.get(environment.baseApiUrl + 'config/v1/user-column-settings/list/module/' + module_id + '/client/' + application_id);
  }

  postUserColumnSettings(body) {
    return this.http.post(environment.baseApiUrl + 'config/v1/user-column-settings', body);
  }

  //  *---------------Masterdata Document Type-----------------*
  getDocumentType(body: {}, is_export: boolean = false) {
    if (is_export) {
      return this.http.post(environment.baseApiUrl + `common/v1/document-type/list`, body, { observe: 'response', responseType: 'blob' });
    } else {
      return this.http.post(environment.baseApiUrl + `common/v1/document-type/list`, body);
    }
  }
  postDocumentType(body: {}) {
    return this.http.post(environment.baseApiUrl + 'common/v1/document-type', body);
  }
  deleteDocumentType(id) {
    return this.http.delete(environment.baseApiUrl + `common/v1/document-type/${id}`);
  }
  updateDocumentType(body: {}, id) {
    return this.http.put(environment.baseApiUrl + `common/v1/document-type/${id}`, body);
  }

  //  *---------------Masterdata Document Field-----------------*
  getDocumentFieldConfig(body, is_export: boolean = false) {
    if (is_export) {
      return this.http.post(environment.baseApiUrl + `document/v1/document-field/list`, body, { observe: 'response', responseType: 'blob' });
    } else {
      return this.http.post<any>(environment.baseApiUrl + `document/v1/document-field/list`, body);
    }
  }
  postDocumentField(body: {}) {
    return this.http.post(environment.baseApiUrl + 'document/v1/document-field', body);
  }
  deleteDocumentField(id) {
    return this.http.delete(environment.baseApiUrl + `document/v1/document-field/${id}`);
  }
  updateDocumentField(body: {}, id) {
    return this.http.put(environment.baseApiUrl + `document/v1/document-field/${id}`, body);
  }

  postDocumentFieldLibrary(body) {
    return this.http.post(environment.baseApiUrl + 'document/v1/document-field/library', body);
  }

  getDocumentFieldLibrary(body) {
    return this.http.post(environment.baseApiUrl + 'document/v1/document-field/library/list', body);
  }

  getRoleList(body: {}, isExport: boolean = false) {
    if (!isExport) {
      return this.http.post(environment.baseApiUrl + 'admin/v1/role/list', body);
    }
    else {
      return this.http.post(environment.baseApiUrl + 'admin/v1/role/list', body, { observe: 'response', responseType: 'blob' });
    }
  }

  submitColumnSetting(body: {}) {
    return this.http.post(environment.baseApiUrl + 'config/v1/bulk-configurations', body);
  }

  addRole(body: {}) {
    return this.http.post(environment.baseApiUrl + 'admin/v1/role', body);
  }

  updateRole(body: {}, id: string) {
    return this.http.put(environment.baseApiUrl + 'admin/v1/role/' + id, body);
  }

  deleteRole(id: string) {
    return this.http.delete(environment.baseApiUrl + 'admin/v1/role/' + id);
  }

  // getPrivilegelist(body: {}) {
  //   return this.http.post(environment.baseApiUrl + "admin/v1/role-permission/list", body);
  // }

  getCurrencyList(body, is_export: boolean = false) {
    if (is_export) {
      return this.http.post(environment.baseApiUrl + 'common/v1/currency/list', body, { observe: 'response', responseType: 'blob' });
    } else {
      return this.http.post<any>(environment.baseApiUrl + 'common/v1/currency/list', body);
    }
  }

  //  *---------------Administration Application-----------------*
  getApplicationList(body, is_export: boolean = false) {
    if (is_export) {
      return this.http.post(environment.baseApiUrl + `user/v1/application/list`, body, { observe: 'response', responseType: 'blob' });
    } else {
      return this.http.post<any>(environment.baseApiUrl + `user/v1/application/list`, body);
    }
  }
  getApplicationListShortInfo() {
    return this.http.get<any>(environment.baseApiUrl + `user/v1/application/short/info`);
  }
  getApplicationLogo(application_id) {
    return this.http.get(environment.baseApiUrl + 'user/v1/application/logo/' + application_id);
  }
  generateAppApiToken(body: {}) {
    return this.http.post(environment.baseApiUrl + 'user/v1/token/generate', body);
  }
  reGenerateAppApiToken(body: {}, token_id) {
    return this.http.post(environment.baseApiUrl + 'user/v1/token/reset/' + token_id, body);
  }
  getAppApiToken(id) {
    return this.http.get(environment.baseApiUrl + 'user/v1/tokens/' + id);
  }
  postApplication(body: {}) {
    return this.http.post(environment.baseApiUrl + 'user/v1/application/register', body);
  }
  deleteApplication(id) {
    return this.http.delete(environment.baseApiUrl + `user/v1/application/${id}`);
  }
  updateApplication(body: {}, id) {
    return this.http.put(environment.baseApiUrl + `user/v1/application/modify/${id}`, body);
  }

  getApplicationPrivilegeList(body) {
    return this.http.post<any>(environment.baseApiUrl + `document/v1/user/application/privilege/list`, body);
  }

  getApplicationPrivileges() {
    return this.http.get<any>(environment.baseApiUrl + `admin/v1/master-privileges/grouped`);
  }

  getUserDocumentTypeList(body) {
    return this.http.post<any>(environment.baseApiUrl + `document/v1/user/document-type/list`, body);
  }
  getUserBusinessUnitList(body) {
    return this.http.post<any>(environment.baseApiUrl + `document/v1/user/business-unit/list`, body);
  }

  //  *---------------Administration Announcement-----------------*
  getAnnouncementList(body, is_export: boolean = false) {
    if (is_export) {
      return this.http.post(environment.baseApiUrl + `notification/v1/announcement/list`, body, { observe: 'response', responseType: 'blob' });
    } else {
      return this.http.post<any>(environment.baseApiUrl + `notification/v1/announcement/list`, body);
    }
  }
  getAnnouncementListAdmin(body, is_export: boolean = false) {
    if (is_export) {
      return this.http.post(environment.baseApiUrl + `notification/v1/announcement/list/admin`, body, { observe: 'response', responseType: 'blob' });
    } else {
      return this.http.post<any>(environment.baseApiUrl + `notification/v1/announcement/list/admin`, body);
    }
  }
  postAnnouncement(body: {}) {
    return this.http.post(environment.baseApiUrl + 'notification/v1/announcement', body);
  }
  updateAnnouncement(body: {}, id) {
    return this.http.put(environment.baseApiUrl + `notification/v1/announcement/${id}`, body);
  }
  deleteAnnouncement(id) {
    return this.http.delete(environment.baseApiUrl + `notification/v1/announcement/${id}`);
  }

  //  *---------------Administration RetentionPolicy-----------------*
  getRetentionPolicyList(body, is_export: boolean = false) {
    if (is_export) {
      return this.http.post(environment.baseApiUrl + `admin/v1/retention/policy/list`, body, { observe: 'response', responseType: 'blob' });
    } else {
      return this.http.post<any>(environment.baseApiUrl + `admin/v1/retention/policy/list`, body);
    }
  }
  postRetentionPolicy(body: {}) {
    return this.http.post(environment.baseApiUrl + 'admin/v1/retention/policy', body);
  }
  deleteRetentionPolicy(id) {
    return this.http.delete(environment.baseApiUrl + `admin/v1/retention/policy/${id}`);
  }
  updateRetentionPolicy(body: {}, id) {
    return this.http.put(environment.baseApiUrl + `admin/v1/retention/policy/${id}`, body);
  }


  getUserActivityLogs(body, is_export: boolean = false) {
    if (is_export) {
      return this.http.post(environment.baseApiUrl + `notification/v1/admin/user-activity/list`, body, { observe: 'response', responseType: 'blob' });
    } else {
      return this.http.post<any>(environment.baseApiUrl + `notification/v1/admin/user-activity/list`, body);
    }
  }

  getEmailLogs(body, is_export: boolean = false) {
    if (is_export) {
      return this.http.post(environment.baseApiUrl + `document/v1/email/log`, body, { observe: 'response', responseType: 'blob' });
    } else {
      return this.http.post<any>(environment.baseApiUrl + `document/v1/email/log`, body);
    }
  }

  getDataChangeLogs(body, is_export: boolean = false) {
    if (is_export) {
      return this.http.post(environment.baseApiUrl + `notification/v1/history/data_change/log`, body, { observe: 'response', responseType: 'blob' });
    } else {
      return this.http.post<any>(environment.baseApiUrl + `notification/v1/history/data_change/log`, body);
    }
  }

  //  *---------------Administration RetentionPolicy-----------------*
  getAppDocConfigList(body, is_export: boolean = false) {
    if (is_export) {
      return this.http.post(environment.baseApiUrl + `document/v1/application/document/type/list`, body, { observe: 'response', responseType: 'blob' });
    } else {
      return this.http.post<any>(environment.baseApiUrl + `document/v1/application/document/type/list`, body);
    }
  }
  postAppDocConfig(body: {}) {
    return this.http.post(environment.baseApiUrl + 'document/v1/application/document/type', body);
  }
  deleteAppDocConfig(id) {
    return this.http.delete(environment.baseApiUrl + `document/v1/application/document/type/${id}`);
  }
  updateAppDocConfig(body: {}, id) {
    return this.http.put(environment.baseApiUrl + `document/v1/application/document/type/${id}`, body);
  }

  //  *---------------Masterdata File Type-----------------*
  getFileTypeList(body, is_export: boolean = false) {
    if (is_export) {
      return this.http.post(environment.baseApiUrl + `common/v1/file-type/list`, body, { observe: 'response', responseType: 'blob' });
    } else {
      return this.http.post<any>(environment.baseApiUrl + `common/v1/file-type/list`, body);
    }
  }
  postFileType(body: {}) {
    return this.http.post(environment.baseApiUrl + 'common/v1/file-type', body);
  }
  deleteFileType(id) {
    return this.http.delete(environment.baseApiUrl + `common/v1/file-type/${id}`);
  }
  updateFileType(body: {}, id) {
    return this.http.put(environment.baseApiUrl + `common/v1/file-type/${id}`, body);
  }

  //  *---------------Connectivity API-----------------*
  getConnectivityList(body, is_export: boolean = false) {
    if (is_export) {
      return this.http.post(environment.baseApiUrl + `connectivity/setup/filter`, body, { observe: 'response', responseType: 'blob' });
    } else {
      return this.http.post<any>(environment.baseApiUrl + `connectivity/setup/filter`, body);
    }
  }
  postConnectivity(body: {}) {
    return this.http.post(environment.baseApiUrl + `connectivity/setup?client_id=${this.clientId}`, body);
  }
  deleteConnectivity(id) {
    return this.http.delete(environment.baseApiUrl + `connectivity/setup/${id}?client_id=${this.clientId}`);
  }
  updateConnectivity(body: {}, id) {
    return this.http.put(environment.baseApiUrl + `connectivity/setup/${id}?client_id=${this.clientId}`, body);
  }

  //  *---------------Connectivity FTP API-----------------*
  postFTPConnectivity(body: {}) {
    return this.http.post(environment.baseApiUrl + `connectivity/ftp?client_id=${this.clientId}`, body);
  }
  getFTPConnectivity(id) {
    return this.http.get(environment.baseApiUrl + `connectivity/ftp/${id}?client_id=${this.clientId}`);
  }
  deleteFTPConnectivity(id) {
    return this.http.delete(environment.baseApiUrl + `connectivity/ftp/${id}?client_id=${this.clientId}`);
  }
  updateFTPConnectivity(body: {}, id) {
    return this.http.put(environment.baseApiUrl + `connectivity/ftp/${id}?client_id=${this.clientId}`, body);
  }

  //  *---------------Connectivity SFTP API-----------------*
  postSFTPConnectivity(body: {}) {
    return this.http.post(environment.baseApiUrl + `connectivity/sftp?client_id=${this.clientId}`, body);
  }
  getSFTPConnectivity(id) {
    return this.http.get(environment.baseApiUrl + `connectivity/sftp/${id}?client_id=${this.clientId}`);
  }
  deleteSFTPConnectivity(id) {
    return this.http.delete(environment.baseApiUrl + `connectivity/sftp/${id}?client_id=${this.clientId}`);
  }
  updateSFTPConnectivity(body: {}, id) {
    return this.http.put(environment.baseApiUrl + `connectivity/sftp/${id}?client_id=${this.clientId}`, body);
  }

  //  *---------------Connectivity SMTP API-----------------*
  postSMTPConnectivity(body: {}) {
    return this.http.post(environment.baseApiUrl + `connectivity/smtp?client_id=${this.clientId}`, body);
  }
  getSMTPConnectivity(id) {
    return this.http.get(environment.baseApiUrl + `connectivity/smtp/${id}?client_id=${this.clientId}`);
  }
  deleteSMTPConnectivity(id) {
    return this.http.delete(environment.baseApiUrl + `connectivity/smtp/${id}?client_id=${this.clientId}`);
  }
  updateSMTPConnectivity(body: {}, id) {
    return this.http.put(environment.baseApiUrl + `connectivity/smtp/${id}?client_id=${this.clientId}`, body);
  }

  //  *---------------Masterdata Rate Sheet-----------------*
  getChargeSheetList(body, is_export: boolean = false) {
    if (is_export) {
      return this.http.post(environment.baseApiUrl + `common/v1/charge-sheet/list`, body, { observe: 'response', responseType: 'blob' });
    } else {
      return this.http.post<any>(environment.baseApiUrl + `common/v1/charge-sheet/list`, body);
    }
  }
  postChargeSheet(body: {}) {
    return this.http.post(environment.baseApiUrl + 'common/v1/charge-sheet', body);
  }
  deleteChargeSheet(id) {
    return this.http.delete(environment.baseApiUrl + `common/v1/charge-sheet/${id}`);
  }
  updateChargeSheet(body: {}, id) {
    return this.http.put(environment.baseApiUrl + `common/v1/charge-sheet/${id}`, body);
  }

  postChargeSheetThroughProcessingFee(body: {}) {
    return this.http.post(environment.baseApiUrl + 'common/v1/charge-sheet/filter/processing-fee', body);
  }

  saveFilterTemplate(body: {}) {
    return this.http.post(environment.baseApiUrl + 'document/v1/user-preference', body);
  }

  getFilterTemplateList(body: {}) {
    return this.http.post(environment.baseApiUrl + 'document/v1/user-preference/filter-template/list', body);
  }
  deleteFilterTemplateById(module_id: {}) {
    return this.http.delete(environment.baseApiUrl + 'document/v1/user-preference/destroy/' + module_id);
  }


  // profile modify

  updateProfileDetails(body: {}) {
    return this.http.put<any>(environment.baseApiUrl + 'user/v1/profile/modify', body);
  }


  //Client List api

  getAllClient(body: {}, isExport: boolean = false) {
    if (!isExport) {
      return this.http.post(environment.baseApiUrl + 'user/v1/client/list', body);
    }
    else {
      return this.http.post(environment.baseApiUrl + 'user/v1/client/list', body, { observe: 'response', responseType: 'blob' });
    }
  }

  //Company List api

  getAllCompany(body: {}, isExport: boolean = false) {
    if (!isExport) {
      return this.http.post(environment.baseApiUrl + 'master/v1/company/list', body);
    }
    else {
      return this.http.post(environment.baseApiUrl + 'master/v1/company/list', body, { observe: 'response', responseType: 'blob' });
    }
  }

  addCompany(body: {}) {
    return this.http.post(environment.baseApiUrl + `master/v1/company?client_id=${this.clientId}`, body);

  }

  updateCompany(body: {}, id: string) {
    return this.http.put(environment.baseApiUrl + `master/v1/company/${id}?client_id=${this.clientId}`, body);
  }

  deleteCompany(id: string) {
    return this.http.delete(environment.baseApiUrl + `master/v1/company/${id}?client_id=${this.clientId}`);
  }

  //Customer List api

  getAllCustomer(body: {}, isExport: boolean = false) {
    if (!isExport) {
      return this.http.post(environment.baseApiUrl + 'master/v1/customer/list', body);
    }
    else {
      return this.http.post(environment.baseApiUrl + 'master/v1/customer/list', body, { observe: 'response', responseType: 'blob' });
    }
  }

  /**sbu apis starts here */
  getAllCustomerSbu(body: {}, isExport: boolean = false, showLoader = true) {
    if (!isExport) {
      return this.http.post(environment.baseApiUrl + 'master/v1/customer-sbu/list', body, {
        context: new HttpContext().set(IS_SHOW_LOADER, showLoader)
      });
    }
    else {
      return this.http.post(environment.baseApiUrl + 'master/v1/customer-sbu/list', body, { observe: 'response', responseType: 'blob' });
    }
  }

  addCustomerSBU(body: {}) {
    return this.http.post(environment.baseApiUrl + `master/v1/customer-sbu?client_id=${this.clientId}`, body);
  }

  updateCustomerSBU(body: {}, id: string){
    return this.http.put(environment.baseApiUrl + `master/v1/customer-sbu/${id}?client_id=${this.clientId}`, body);
  }

  deleteCustomerSBU(id: string){
    return this.http.delete(environment.baseApiUrl + `master/v1/customer-sbu/${id}?client_id=${this.clientId}`);
  }
  /**sbu apis ends here */

  getAllCustomerLSP(body: {}, isExport: boolean = false) {
    if (!isExport) {
      return this.http.post(environment.baseApiUrl + 'master/v1/vendor/list', body);
    }
    else {
      return this.http.post(environment.baseApiUrl + 'master/v1/vendor/list', body, { observe: 'response', responseType: 'blob' });
    }
  }
  addLSPCustomer(body: {}) {
    return this.http.post(environment.baseApiUrl + `master/v1/vendor?client_id=${this.clientId}`, body);
  }

  updateLspCustomer(body: {}, id: string) {
    return this.http.put(environment.baseApiUrl + `master/v1/vendor/${id}?client_id=${this.clientId}`, body);
  }

  deleteLspCustomer(id: string) {
    return this.http.delete(environment.baseApiUrl + `master/v1/vendor/${id}?client_id=${this.clientId}`);
  }


  addCustomer(body: {}) {
    return this.http.post(environment.baseApiUrl + `master/v1/customer?client_id=${this.clientId}`, body);

  }

  updateCustomer(body: {}, id: string) {
    return this.http.put(environment.baseApiUrl + `master/v1/customer/${id}?client_id=${this.clientId}`, body);
  }

  deleteCustomer(id: string) {
    return this.http.delete(environment.baseApiUrl + `master/v1/customer/${id}?client_id=${this.clientId}`);
  }

  //Vendor List api

  getAllVendor(body: {}, isExport: boolean = false, showLoader = true) {
    if (!isExport) {
      return this.http.post(environment.baseApiUrl + 'master/v1/vendor/list', body, {
        context: new HttpContext().set(IS_SHOW_LOADER, showLoader)
      });
    }
    else {
      return this.http.post(environment.baseApiUrl + 'master/v1/vendor/list', body, { observe: 'response', responseType: 'blob' });
    }
  }

  addVendor(body: {}) {
    return this.http.post(environment.baseApiUrl + `master/v1/vendor?client_id=${this.clientId}`, body);

  }

  updateVendor(body: {}, id: string) {
    return this.http.put(environment.baseApiUrl + `master/v1/vendor/${id}?client_id=${this.clientId}`, body);
  }

  deleteVendor(id: string) {
    return this.http.delete(environment.baseApiUrl + `master/v1/vendor/${id}?client_id=${this.clientId}`);
  }


  //auto email template

  getAutoEmailTemplate(body: {}, isExport: boolean = false) {
    if (!isExport) {
      return this.http.post(environment.baseApiUrl + 'tracker_email/email_template/auto/list', body);
    }
    else {
      return this.http.post(environment.baseApiUrl + 'tracker_email/email_template/auto/list', body, { observe: 'response', responseType: 'blob' });
    }
  }

  addAutoEmailTemplate(body: {}) {
    return this.http.post(environment.baseApiUrl + `tracker_email/email_template/auto/create?client_id=${this.clientId}`, body);
  }

  updateAutoEmailTemplate(body: {}, id: string) {
    return this.http.put(environment.baseApiUrl + `tracker_email/email_template/auto/${id}?client_id=${this.clientId}`, body);
  }

  deleteAutoEmailTemplate(id: string) {
    return this.http.delete(environment.baseApiUrl + `tracker_email/email_template/auto/${id}?client_id=${this.clientId}`);
  }

  getEmailTypeList(body: {}) {
    return this.http.post(environment.baseApiUrl + 'common/v1/email_type/list', body);
  }

  //auto email template

  getAutoEmailTemplateController(body: {}, isExport: boolean = false) {
    if (!isExport) {
      return this.http.post(environment.baseApiUrl + 'tracker_email/email_template/controller/list', body);
    }
    else {
      return this.http.post(environment.baseApiUrl + 'tracker_email/email_template/controller/list', body, { observe: 'response', responseType: 'blob' });
    }
  }

  addAutoEmailTemplateController(body: {}) {
    return this.http.post(environment.baseApiUrl + `tracker_email/email_template/controller/create?client_id=${this.clientId}`, body);
  }

  updateAutoEmailTemplateController(body: {}, id: string) {
    return this.http.put(environment.baseApiUrl + `tracker_email/email_template/controller/${id}?client_id=${this.clientId}`, body);
  }

  deleteAutoEmailTemplateController(id: string) {
    return this.http.delete(environment.baseApiUrl + `tracker_email/email_template/controller/${id}?client_id=${this.clientId}`);
  }

  getErrorCodeList(body: {}) {
    return this.http.post(environment.baseApiUrl + `master/v1/error-code/list`, body);
  }

  //manual email template

  getmanualEmailTemplate(body: {}, isExport: boolean = false) {
    if (!isExport) {
      return this.http.post(environment.baseApiUrl + 'tracker_email/email_template/manual/list', body);
    }
    else {
      return this.http.post(environment.baseApiUrl + 'tracker_email/email_template/manual/list', body, { observe: 'response', responseType: 'blob' });
    }
  }

  addmanualEmailTemplate(body: {}, type: boolean) {
    if (type) {
      return this.http.post(environment.baseApiUrl + `tracker_email/email_template/manual/create?client_id=${this.clientId}`, body);
    } else {
      return this.http.post(environment.baseApiUrl + `tracker_email/email_template/manual/private/create?client_id=${this.clientId}`, body);
    }
  }

  updatemanualEmailTemplate(body: {}, id: string, type: boolean) {
    if (type) {
      return this.http.put(environment.baseApiUrl + `tracker_email/email_template/manual/${id}?client_id=${this.clientId}`, body);
    } else {
      return this.http.put(environment.baseApiUrl + `tracker_email/email_template/manual/private/${id}?client_id=${this.clientId}`, body);
    }
  }

  deletemanualEmailTemplate(id: string, type: boolean) {
    if (type) {
      return this.http.delete(environment.baseApiUrl + `tracker_email/email_template/manual/${id}?client_id=${this.clientId}`);
    } else {
      return this.http.delete(environment.baseApiUrl + `tracker_email/email_template/manual/private/${id}?client_id=${this.clientId}`);
    }
  }

  /*---------- Error Code --------------*/
  fetchErrorCode(body: {}) {
    return this.http.post(environment.baseApiUrl + `master/v1/error-code/list`, body);
  }
  postErrorCoede(body: {}) {
    return this.http.post(environment.baseApiUrl + `master/v1/error-code`, body);
  }
  updateErrorCode(body: {}, id: number) {
    return this.http.put(environment.baseApiUrl + `master/v1/error-code/${id}`, body);
  }
  deleteErrorCode(id: number) {
    return this.http.delete(environment.baseApiUrl + `master/v1/error-code/${id}`);
  }

  //  *---------------Administration Docstatus-----------------*
  getDocStatusList() {
    return this.http.get(environment.baseApiUrl + `extraction/v1/action-status/grouped/list?client_id=${this.clientId}`);
  }
  postDocStatus(body: {}) {
    return this.http.post(environment.baseApiUrl + `extraction/v1/document/status/action?client_id=${this.clientId}`, body);
  }
  updateDocStatus(body: {}, id) {
    return this.http.put(environment.baseApiUrl + `extraction/v1/document/status/action/${id}?client_id=${this.clientId}`, body);
  }
  deleteDocStatus(id) {
    return this.http.delete(environment.baseApiUrl + `extraction/v1/document/status/action/${id}?client_id=${this.clientId}`);
  }

  //  *---------------Administration Billing Details-----------------*
  getBillingList(body, is_export: boolean = false) {
    if (!is_export) {
      return this.http.post(environment.baseApiUrl + `common/v1/billing`, body);
    } else {
      return this.http.post(environment.baseApiUrl + `common/v1/billing`, body, { observe: 'response', responseType: 'blob' });
    }
  }
  getBillingData(body: {}) {
    return this.http.post(environment.baseApiUrl + `common/v1/billing/data`, body);
  }
  getClientBillingData(body: {}) {
    return this.http.post(environment.baseApiUrl + `common/v1/client/billing/data`, body);
  }
  getBillingExport(body: {}) {
    return this.http.post(environment.baseApiUrl + `common/v1/billing/export`, body, { observe: 'response', responseType: 'blob' });
  }
  getClientBillingExport(body: {}) {
    return this.http.post(environment.baseApiUrl + `common/v1/client/billing/export`, body, { observe: 'response', responseType: 'blob' });
  }


  // *-----CLient Feature List----*//
  getClientFeatureList(id) {
    return this.http.get(environment.baseApiUrl + `extraction/v1/client/files-docs/${id}`);
  }



  //*------ BRE Config-----*//

  getBREConfigList(body) {
    return this.http.post(environment.baseApiUrl + 'extraction/v1/bre-config/list', body);
  }

  postBREConfig(body) {
    return this.http.post(environment.baseApiUrl + 'extraction/v1/bre-config', body);
  }

  //  *---------------Administration Validation Module-----------------*
  getValidationList(body, is_export: boolean = false) {
    if (!is_export) {
      return this.http.post(environment.baseApiUrl + `extraction/v1/validation-module/list`, body);
    } else {
      return this.http.post(environment.baseApiUrl + `extraction/v1/validation-module/list`, body, { observe: 'response', responseType: 'blob' });
    }
  }
  postValidation(body: {}) {
    return this.http.post(environment.baseApiUrl + `extraction/v1/validation-module?client_id=${this.clientId}`, body);
  }
  updateValidation(body: {}, id) {
    return this.http.put(environment.baseApiUrl + `extraction/v1/validation-module/${id}?client_id=${this.clientId}`, body);
  }
  deleteValidation(id) {
    return this.http.delete(environment.baseApiUrl + `extraction/v1/validation-module/${id}?client_id=${this.clientId}`);
  }

  // Surcharge Tolerance Config Starts here
  getSurchargeToleranceList(body: {}, is_export = false){
    if (is_export) {
      return this.http.post(environment.baseApiUrl + `master/v1/surcharge-tolerance/list`, body, { observe: 'response', responseType: 'blob' });
    } else {
      return this.http.post(environment.baseApiUrl + `master/v1/surcharge-tolerance/list`, body);
    }
    
  }

  addSurchargeTolerance(body){
    return this.http.post(environment.baseApiUrl + `master/v1/surcharge-tolerance/create?client_id=${this.clientId}`, body);
  }

  updateSurchargeTolerance(id, body){
    return this.http.put(environment.baseApiUrl + `master/v1/surcharge-tolerance/${id}?client_id=${this.clientId}`, body);
  }

  deleteSurchargeTolerance(id){
    return this.http.delete(environment.baseApiUrl + `master/v1/surcharge-tolerance/${id}?client_id=${this.clientId}`);
  }
  // Surcharge Tolerance ends here

  getAllUserWithoutLoader(body: {}, isExport: boolean = false) {
    if (!isExport) {
      return this.http.post(environment.baseApiUrl + 'user/v1/list', body, {
        context: new HttpContext().set(IS_SHOW_LOADER, false)
      });
    }
    else {
      return this.http.post(environment.baseApiUrl + 'user/v1/list', body, { observe: 'response', responseType: 'blob' });
    }
  }


  preparePayload(payload: any): any {
    const filteredPayload = { ...payload };
    Object.keys(filteredPayload).forEach(key => {
      const startDateKey = `${key}_start_date`;
      const endDateKey = `${key}_end_date`;
      if (filteredPayload[startDateKey]) {
        if (filteredPayload[endDateKey] == null) { // Check if end_date is null or undefined
          filteredPayload[endDateKey] = filteredPayload[startDateKey];
          delete filteredPayload[key];
        } else if (filteredPayload[startDateKey] && filteredPayload[endDateKey]) {
          delete filteredPayload[key];
        }
      }
    });
    return filteredPayload;
  }

  initializeFilterModel(column_list) {
    let filterModel = {};

    column_list.forEach(col => {
      if (col.is_filterable) {
        if (col.filter_type === 'calendar') {
          filterModel[`${col.key}_start_date`] = null;
          filterModel[`${col.key}_end_date`] = null;
        }
        else if (col.filter_type === 'input') {
          if (col.key.endsWith('_by')) {
            filterModel[col.key] = null;
            filterModel[`${col.key}_name`] = null;
          }
          else if (col.key.endsWith('_to')) {
            filterModel[col.key] = null;
            filterModel[`${col.key}_name`] = null;
          }
          else {
            filterModel[col.key] = null;
          }
        }
        else {
          filterModel[col.key] = null;
        }
      }
    });
    return filterModel;
  }

  groupData(listData: any[]) {
    // Initialize groups
    const activeData = listData.filter(app => app.status);
    const inactiveData = listData.filter(app => !app.status);

    // Create grouped list with headers
    let groupedList = [];

    if (activeData.length > 0) {
      groupedList.push({
        label: 'Active',
        items: activeData
      });
    }

    if (inactiveData.length > 0) {
      groupedList.push({
        label: 'Inactive',
        items: inactiveData
      });
    }

    return groupedList;
  }

  charToPx(text: string, fontSize: string = '13px', fontFamily: string = 'Montserrat'): number {
    const span = document.createElement('span');
    span.style.position = 'absolute';
    span.style.visibility = 'hidden';
    span.style.font = `${fontSize} ${fontFamily}`;
    span.textContent = text;
    document.body.appendChild(span);
    const width = span.offsetWidth;
    document.body.removeChild(span);
    return width;
  };

  /**
   * Converts the privileges array into a formatted structure.
   * @param privileges The array of privileges.
   * @returns The formatted privileges structure.
   */
  convertPrivileges(privileges: any[]): any[] {
    const formattedPrivileges = {};

    privileges.forEach((privilege) => {
      const moduleId = parseInt(privilege.module_id, 10);
      const moduleName = Settings.MasterModule[privilege.module_id];

      // If the module ID does not exist in the formattedPrivileges object,
      // create a new entry for it.
      if (!formattedPrivileges[moduleId]) {
        formattedPrivileges[moduleId] = {
          label: moduleName,
          id: moduleId,
          items: [],
        };
      }

      // Add the privilege to the corresponding module entry.
      formattedPrivileges[moduleId].items.push({
        id: moduleId,
        label: privilege.name.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase()),
        value: privilege.name,
      });

    });

    // Return the formatted privileges as an array.
    return Object.values(formattedPrivileges);
  }
}